import {gql} from '@apollo/client';
import React from 'react';

import {assert} from 'Asserts';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {NumItemsInTagSchemaQuery} from './__generated/NumItemsInTagSchemaQuery';
import {
  FieldMigrationCreationModal,
  SchemaSpecificFieldMigrationCreationModalProps,
} from './FieldMigrationCreationModal';

export const NUM_ITEMS_IN_TAG_SCHEMA_QUERY = gql`
  query NumItemsInTagSchemaQuery($id: StrictString!) @skipAudit @engComponent(name: SCHEMAS) {
    tagSchema(id: $id) {
      ... on TagSchemaNode {
        id
        numItems
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export function TagSchemaFieldMigrationCreationModal(
  props: SchemaSpecificFieldMigrationCreationModalProps
): JSX.Element {
  const numItemQueryResult = useBenchlingQuery<NumItemsInTagSchemaQuery>(NUM_ITEMS_IN_TAG_SCHEMA_QUERY, {
    variables: {id: props.schemaId},
  });

  let numItems: number | null = null;
  if (numItemQueryResult.type === QueryResultType.SUCCESS) {
    assert(
      !isInaccessible(numItemQueryResult.data.tagSchema),
      `Expecting to fetch the num items for a TagSchema, but it was inaccessible (tagSchemaId=${props.schemaId})`
    );
    numItems = numItemQueryResult.data.tagSchema?.numItems;
  }

  return <FieldMigrationCreationModal {...props} numItems={numItems} />;
}
